import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css"
import styles from 'shared/styles.css';
import { actions as storeLocationActions } from 'redux/domain/StoreLocation';
import { actions as userActions } from 'redux/domain/User';
import {
	IMAGES_SMALL,
	IMAGES_MEDIUM,
	IMAGES_LARGE,
	getHomeImages,
} from 'shared/utils/imagesHelpers';
import throttle from 'lodash.throttle';
import Customer from 'models/Customer';
import { getStoreLocation } from 'shared/utils/storeLocationHelpers';
import homeStyles from './styles.css';
import withRouter from '../../../shared/utils/WithRouter';

class HomeContainer extends React.Component {
	constructor() {
		super();
		this.state = {
			images: [],
			imageSize: '',
		};

		this.handleResize = throttle(this.handleResize.bind(this), 300);
	}

	UNSAFE_componentWillMount() {
		const nopWarehouseId = getStoreLocation();
		if (nopWarehouseId === 0) {
			this.props.openStoreModal();
		}
	}

	componentDidMount() {
		// Set up a new guest customer for the next user.
		const { customer, getGuestCustomer } = this.props;

		if (customer.id == null) {
			getGuestCustomer();
		}

		// select image with closest aspect ratio
		this.handleResize();

		// Support resize for better image display
		window.addEventListener('resize', this.handleResize, false);
	}

	componentWillReceiveProps(nextProps) {
		// When logging out we send an asynchronous request to delete the carts, destroy the authentication token,
		// and reset the customer. When the cleanup is complete the reset customer will come in as a prop.
		const { customer } = nextProps;
		const { getGuestCustomer } = this.props;
		if (customer.id == null) {
			getGuestCustomer();
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	/**
	 * Handle the resize event. When the screen resizes, adjust the images
	 */
	handleResize() {
		const windowWidth = window.innerWidth;
		const currentSize = this.state.imageSize;
		// set breakpoints based on material ui: https://material-ui-1dab0.firebaseapp.com/layout/basics/
		if (window.innerHeight > windowWidth) {
			// this is portrait
			this.setState({ images: getHomeImages(IMAGES_SMALL), imageSize: IMAGES_SMALL });
		} else if (windowWidth >= 1280) {
			if (currentSize !== IMAGES_LARGE) {
				this.setState({ images: getHomeImages(IMAGES_LARGE), imageSize: IMAGES_LARGE });
			}
		} else if (currentSize !== IMAGES_MEDIUM) {
			this.setState({ images: getHomeImages(IMAGES_MEDIUM), imageSize: IMAGES_MEDIUM });
		}
	}

	// this will auto scale images to the size of the container
	renderImage = item => (		
		<img src={item.original} alt="productImg" className={homeStyles['home-image']} />
	);

	render() {
		return (
			<div className={styles.fullscreen}>
				<ImageGallery
					items={this.state.images}
					autoPlay={true}
					slideInterval={6000}
					slideDuration={1500}
					showFullscreenButton={false}
					showPlayButton={false}
					showThumbnails={false}
					renderItem={this.renderImage}
					onClick={() => this.props.router.navigate('/category')}
				/>
			</div>
		);
	}
}

HomeContainer.propTypes = {
	customer: PropTypes.instanceOf(Customer).isRequired,
	getGuestCustomer: PropTypes.func.isRequired,
	openStoreModal: PropTypes.func.isRequired,
};

// make state available via props
const mapStateToProps = state => {
	const customer = state.user.get('customer');
	return {
		customer,
	};
};

// make actions from two domains available via props
const mapDispatchToProps = dispatch =>
	bindActionCreators({ ...storeLocationActions, ...userActions }, dispatch);

// for testing purposes
export { HomeContainer as HomeContainerClass };

// connect returns a function that accepts a component
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeContainer));
